// extracted by mini-css-extract-plugin
export default {"Image":"SmartImage_Image__CNZaG"};